import React, { Component, useContext } from 'react';
import { BankUserContext } from '../../bankUserContext';
import { BankUserContextInterface } from '../../models/BankUserContext';

interface RoleAuthorizationProps {
  page: string;
  action: string;
}

interface claims {
  resource_name:string;
  component_names:Array<string>;
}

const withContext = (bankUserContext:BankUserContextInterface|undefined,page:string,action:string,productId?:string) => {

  const secuirty = (claims:claims[]) => {
    const claimsObject = claims?.find((each:claims)=>{if(page.match(each.resource_name)) return each})
  
    if(claimsObject && claimsObject.component_names?.indexOf(action) >-1){
        return true
   }
   return false
  }
  
    if(bankUserContext?.bankRolesData?.claims && page && action){
      //   const rolesKey=bankUserContext?.bankRolesData.claims.find((each:any)=>{if(page?.match(Object.keys(each)[0]))return each})
        
      //   if(rolesKey){      
      //     for (const key in rolesKey) {
      //       if (rolesKey.hasOwnProperty(key)) {
      //         const value = rolesKey[key];
      //         if (value.includes(action)) {
      //           return true; 
      //         }
      //       }
      //     }   
      // return false
      //   }else{
      //       return false
      //   }
      if(productId){
       const productClaims=  bankUserContext.bankRolesData?.products.find((m: { orgLevelProductId: any;productId:any; })=>m.productId === productId);
       
       if(productClaims){
        return secuirty(productClaims.claims)
       }
      }else{
        const {claims}=bankUserContext.bankRolesData
        return secuirty(claims);
      }
      
     
      return false
       }

    
    return false
  };

class RoleAuthorizationCC extends Component<any> {
    static contextType = BankUserContext;
    context: React.ContextType<typeof BankUserContext> | undefined;
   
  // checkAuthorization(page: string, action: string): boolean {
  //   console.log(this.context);
  //   if (this.context?.bankRolesData?.claims) {
  //     const rolesKey = this?.context.bankRolesData.claims.find(
  //       (each: Claims) => {
  //         if (Object.keys(each)?.includes(page)) return each;
  //       }
  //     );

  //     if (rolesKey) {
  //       if (rolesKey[page]?.includes(action)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     } else {
  //       return false;
  //     }
  //   }

  //   return false;
  // }

  render() {
    const { page, action , productId } = this.props;
    const bankUserContext = this.context;
    if (bankUserContext?.bankRolesData?.claims) {
   return withContext(bankUserContext,page,action, productId)
    }
    return false;
  }
}

export { RoleAuthorizationCC,withContext};
